import axios, { AxiosResponse } from "axios";
import { showToast, ToastTypeCode } from "./Constant";
import { AppConfig } from "../AppConfig";
const baseUrl = `${AppConfig.BASE_URL}/api`;
let token = localStorage.getItem("accessToken");

export let config = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

const getConfig = () => {
  const token = localStorage.getItem("accessToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const handleUnauthorized = () => {
  localStorage.removeItem("accessToken");
  window.location.href = "/unauthorized";
  showToast("Unauthorized, Please Login Again", ToastTypeCode?.ERROR);
};
const handleUnauthorizedData = () => {
  localStorage.removeItem("accessToken");
  window.location.href = "/forbidden";
  showToast("Unauthorized", ToastTypeCode?.ERROR);
};

const axiosPost = (reqUrl: string, reqBody: any) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrl}${reqUrl}`, reqBody, getConfig())
      .then(function (response: any) {
        if (response.status === 200 || 202) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.removeItem("accessToken");
            //window.location.href = `${process.env.REACT_APP_MY_BASE_URL}/login`;
            handleUnauthorized();
          } else if (error.response.status === 403) {
            // localStorage.removeItem("accessToken");
            //window.location.href = `${process.env.REACT_APP_MY_BASE_URL}/login`;
            console.log("error ", error.response.ErrorMessage);

            handleUnauthorizedData();
          } else if (error.response.status === 409) {
            resolve(error.response);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          //localStorage.removeItem("accessToken");
          //window.location.href = "http://localhost:3000/login";
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
          showToast("Network Error", ToastTypeCode?.ERROR);
        }
        reject(error);
      });
  });
};

const axiosPatch = (reqUrl: string, reqBody: any = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(baseUrl + reqUrl, reqBody, config)
      .then(function (response: any) {
        if (response.status === 200 || 202) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            showToast("Unauthorized", ToastTypeCode?.ERROR);
            handleUnauthorized();
          }
          if (error.response.status === 409) {
            resolve(error);
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosGet = <T>(
  reqUrl: string,
  reqParams: any = {}
): Promise<AxiosResponse<T>> => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + reqUrl, { params: reqParams, ...config })
      .then(function (response: AxiosResponse<T>) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.removeItem("accessToken");
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

const axiosDelete = (reqUrl: string) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(baseUrl + reqUrl, {}, config)
      .then(function (response: any) {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.removeItem("accessToken");
            window.location.href = "http://localhost:3000/login";
          } else {
            console.log("error", error.response.data.error);
          }
        } else if (error.request) {
          console.log(
            "error on the server and the request could not be completed.",
            error.request
          );
        }
        reject(error);
      });
  });
};

export { axiosDelete, axiosGet, axiosPatch, axiosPost };
